import Square from "./Square";
import '../index.css'

const Board = ({ squares, onCLick }) => (
    <div className="board">
        {squares.map((square, i) => (
            <Square key={i} value={square} onClick={() => onCLick(i)} />
        ))}
    </div>
)

export default Board